export const EnumPerfis = {
  ADMINISTRADOR: "ADMINISTRADOR",
  GTR: "GTR",
  SINGULAR: "SINGULAR",
  UB_CONSULTA: "UB_CONSULTA",
  FEDERACAO_CONSULTA: "FEDERACAO_CONSULTA",
  ADM_RECURS_PROPRIO: "ADM_RECURS_PROPRIO"
};
